import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const FileDeliveryChromeAppButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-unlock-alt fa-fw"
        clickHandler={clickHandler}
        title={t('options.fileDeliveryChromeApp')}
        a11yAttributes={a11yAttributes}
    />);
};

FileDeliveryChromeAppButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default FileDeliveryChromeAppButton;
